'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import BaseFilter from '../Base';
import { Checkbox, Select } from '../../Controls';
import ToggleViewMode from '../../../ui/Controls/ToggleViewMode';

class QuickFilterBase extends BaseFilter {
  renderViewSelect () {
    return (
      <ToggleViewMode
        className='quick-toggle-view-mode'
        viewMode={this.getValue('viewMode')}
        onUpdate={this.props.onUpdate} />
    );
  }

  renderSort (items) {
    return (
      <Select
        items={items}
        name='sort'
        label='Сортировка'
        value={this.getValue('sort')}
        onUpdate={this.handlerSelect('sort')}
      />
    );
  }

  renderDataSource (items) {
    const viewDataSource = this.props.user.getIn(['data', 'permissions', 'viewDataSource'], null) || null;
    return viewDataSource && (
      <Select
        items={items}
        name='dataSourceId'
        label=''
        value={this.getValue('dataSourceId')}
        onUpdate={this.handlerSelect('dataSourceId')}
      />
    );
  }

  renderMyObject () {
    return (
        this.getUserId() > 0 && !this.getUserIsAdmin() &&
        <Checkbox
          label='Только мои объявления'
          checked={this.getValue('userId')}
          onUpdate={this.handlerMyObjects(this.getUserId())}
        />
    );
  }

  renderInterval (dealType, realtyType) {
    const items = this.props.dictionary.getIntervalInsertedItems(dealType, realtyType);

    return (
      <Select
        name='interval'
        label='Новые'
        items={items}
        value={this.getValue('interval')}
        scrolling
        onUpdate={this.handlerSelect('interval')}
      />
    );
  }

  render () {
    return null;
  }
}

QuickFilterBase.propTypes = {
  user: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,
  dictionary: PropTypes.object.isRequired,

  onUpdate: PropTypes.func.isRequired
};

export default QuickFilterBase;



// WEBPACK FOOTER //
// ./src/ui/Search/QuickFilter/QuickFilterBase.jsx